import { Component, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'townip-panel-t2',
  templateUrl: './panel-t2.component.html',
  styleUrls: ['./panel-t2.component.scss']
})
export class PanelT2Component implements OnInit {

  @Input()
  public heading: string;

  @Input()
  public theme: 'default' | 'gray' = 'default';

  @Input()
  public action: TemplateRef<any>;

  @Input()
  public active = false;

  @Input()
  public headingSize: 'lg' | 'md' | 'sm' = 'md';

  @Input()
  public badge: string;

  @Input()
  public badgeTheme: string = 'primary';

  @Input()
  public icon: TemplateRef<any>;

  @Input()
  public iconPosition: 'left' | 'right' = 'left';

  @Input()
  public badgePosition: 'left' | 'right'  = 'right';

  constructor() { }

  public ngOnInit(): void { }

}
